
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import ListClientRegistrationV1 from "../clients/client-registration/index.vue";
import ListClientRegistrationV2 from "../clients-v2/registration/index.vue";
import { Options, Vue } from "vue-class-component";
@Options({
  components: {
    ListClientRegistrationV1,
    ListClientRegistrationV2,
  },
})
export default class EntryClient extends Vue {
  get isClientVersionV2() {
    return FlagsPermissionClient.client_v2_enable.isEnabled();
  }

  get renderedPage(): string {
    return this.isClientVersionV2
      ? "ListClientRegistrationV2"
      : "ListClientRegistrationV1";
  }
}
